/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import xClose from "../../../../images/x_close.svg"
import Button from "../../../../components/button"
import { windowObject } from "../../../../utils/browser-helpers"
import { graphql, useStaticQuery } from 'gatsby'
import { isMobile, isAndroid, isIOS } from "react-device-detect";
import { initCheckout } from "../../../../utils/premium-helpers"
import bannerModalePremium from "../../../../images/premium/banner_modale_premium.png"
import * as s from "./css/modal-pagamento.module.css"
import Bullet from "../../../../components/bullet"

const ModalPagamento = ({ project, visible, requestClose, goNext }) => {

    const gqlFilesDownload = useStaticQuery(graphql`
    {
      allFile(filter: { sourceInstanceName: { eq: "filesSupport" } }) {
          edges {
          node {
            publicURL
            base
          }
        }
      }
    }
    `)

    const [chkCondizioniGenerali, setChkCondizioniGenerali] = useState(false);
    const [chkClausole, setChkClausole] = useState(false);
    const [isDocumentDownloaded, setIsDocumentDownloaded] = useState(false);

    const condizioniGeneraliUsoAppTinabaPdf = gqlFilesDownload.allFile.edges.find(e => e.node.base === process.env.PREMIUM_APP_TINABA_USE_CONDITIONS_PDF_NAME);
    const condizioniGeneraliUsoAppTinabaPdfUrl = condizioniGeneraliUsoAppTinabaPdf ? condizioniGeneraliUsoAppTinabaPdf.node.publicURL : null;

    const isPagaAbilitato = () => chkClausole && chkCondizioniGenerali;


    const onExitTap = () => {
        if (requestClose) {
            requestClose();
        }
    }

    const onPagaTap = async () => {
        if (isMobile) {
            console.log('onPagaTap-mobile');
            const respInit = await initCheckout();
            if (respInit.success) {
                const paymentCode = respInit.json.qrCodeValue;
                payWithTinaba(paymentCode);
            }
            else {

            }
        }
        else {
            console.log('onPagaTap-desktop');
            const wObj = windowObject();
            if (wObj) {
                wObj.location.href = `${process.env.PAGES_BASE_URL}/${project.alias}/payment`;
            }
        }
    }

    const forceDownload = (urlToDownload, filename) => {
        fetch(urlToDownload)
        .then(response => response.blob())
        .then(blob => URL.createObjectURL(blob))
        .then(url => {
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    const onDocumentDownloadTap = () => {

        forceDownload(condizioniGeneraliUsoAppTinabaPdfUrl, 'condizioni_generali_uso_tinaba.pdf');

        setIsDocumentDownloaded(true);
    }

    const onRegistratiTap = () => {
        if (isMobile) {
            console.log('onRegistratiTap-mobile');
            window.location.replace(isIOS ? tinabaConfig.appleStoreLink : tinabaConfig.googleStoreLink);
        }
        else {
            console.log('onRegistratiTap-desktop');
            const wObj = windowObject();
            if (wObj) {
                wObj.location.href = `${process.env.REGISTRATION_URL}`;
            }
        }
    }

    const tinabaConfig = {
        appleStoreLink: 'https://itunes.apple.com/it/app/tinaba/id1063359568?mt=8',
        googleStoreLink: 'market://details?id=it.tinaba.app'
    };

    const openFallback = (ts) => {
        return function () {
            const wait = 1000 + 500;
            if (typeof tinabaConfig.googleStoreLink === "string" && (Date.now() - ts) < wait) {
                const wObj = windowObject();
                if (wObj) {
                    wObj.location.href = tinabaConfig.googleStoreLink;
                }
            }
        }
    }

    const getTinabaPayUrl = (paymentCode) => {
        let viaBrowserDeeplinkUrl = `http://www.tinaba.com/dl`,
            params = '?';
        const scheme = 'it.tinaba.app',
            path = '/dl';

        params += `paymentcode=${encodeURIComponent(paymentCode)}`;

        let deeplinkUrl = `${scheme}:/${path}${params}`;
        viaBrowserDeeplinkUrl += params;
        viaBrowserDeeplinkUrl += `&tinabaPay=true`;
        deeplinkUrl += `&tinabaPay=true`;

        return {
            deeplinkUrl,
            viaBrowserDeeplinkUrl
        }
    }

    const payWithTinaba = (paymentCode) => {
        // holds the final URL that will be used in the generated QR code and links to redirection page
        const { deeplinkUrl } = getTinabaPayUrl(paymentCode)
        const wObj = windowObject();

        if (isIOS) {
            const now = (new Date()).valueOf();
            setTimeout(function () {
                if ((new Date()).valueOf() - now > 5500) return;
                window.location.replace(tinabaConfig.appleStoreLink);
            }, 5e3);
            if (wObj) {
                wObj.location.replace(deeplinkUrl)
            }
        } else if (isAndroid) {
            if (wObj) {
                wObj.location.replace(deeplinkUrl)
            }
            setTimeout(openFallback(Date.now()), 1000)
        } else {
            // window.location.replace(deeplinkUrl);
        }
    }

    useEffect(() => {
        if(visible)
        {
            const wObj = windowObject();
            if(wObj)
            {
                wObj.scrollTo(0,0);
            }
        }
    }, [visible]);

    return (
        visible &&
        <>
            <div className={`items-center desktop:justify-center flex flex-col bg-white ${s.container}`}>
                <div className={`container-grid bg-white relative flex-col desktop:flex-row ${s.containerContent}`}>
                    <div className="col-span-4 desktop:col-start-2 desktop:col-span-3 flex items-center">
                        <div className={`flex flex-col items-center ${s.containerBannerImage}`}>
                            <img src={bannerModalePremium} alt="payment" />
                        </div>
                    </div>
                    <div className="col-span-4 desktop:col-start-6 desktop:col-span-5">
                        <div className={`flex flex-col ${s.containerInfo}`}>
                            <div className="text-center text-primary font-md text-24 leading-16 desktop:text-left" style={{ marginTop: '48px' }}>Attiva ora Tinaba Premium</div>
                            <div className="text-center text-black font-rg text-6 leading-6_1 desktop:text-left" style={{ marginTop: '21px' }}>
                                Paga in modo veloce ed ottieni subito la tua membership
                            </div>
                            <div aria-hidden="true" className="shadow-1 cursor-pointer" style={{ marginTop: '32px', padding:'32px' }}  onClick={onDocumentDownloadTap}>
                                <div  className="text-black font-rg text-6" style={{ lineHeight: '21px' }}>
                                    Condizioni generali d'uso di Tinaba
                                </div>
                                {!isDocumentDownloaded && <div className="text-primary text-8" style={{marginTop:'8px'}}>
                                    Leggi per proseguire
                                </div>
                                }
                                {isDocumentDownloaded && <div className="text-8" style={{marginTop:'8px', color:'#666666'}}>
                                    Letto
                                </div>
                                }
                            </div>
                            {isDocumentDownloaded && <div>
                                <div className="flex flex-row w-full" style={{ marginTop: '32px' }}>
                                    <Bullet id="chkCondizioniGenerali" checked={chkCondizioniGenerali} onChange={(checked) => {
                                        setChkCondizioniGenerali(checked);
                                    }} />
                                    <div aria-hidden="true" className="cursor-pointer select-none" style={{ marginLeft: '16px' }} onClick={() => { setChkCondizioniGenerali(!chkCondizioniGenerali) }}>Accetto le Condizioni Generali d'uso di Tinaba</div>
                                </div>
                                <div className="flex flex-row w-full" style={{ marginTop: '32px' }}>
                                    <Bullet id="chkClausole" checked={chkClausole} onChange={(checked) => {
                                        setChkClausole(checked);
                                    }} />
                                    <div aria-hidden="true" className="cursor-pointer select-none" style={{ marginLeft: '16px' }} onClick={() => { setChkClausole(!chkClausole) }}>Accettazione specifica delle clausole di cui all’Art. 7 delle condizioni generali d’uso di Tinaba</div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    <div aria-hidden="true" className="hidden desktop:flex absolute cursor-pointer" style={{ fontSize: '32px', right: '30px', top: '33px' }} onClick={onExitTap}>
                        <img src={xClose} alt="close" />
                    </div>
                </div>
                <div className="container-grid" style={{ height: '1px', backgroundColor: '#eaeaea' }}></div>
                <div className="container-grid bg-white relative flex-col desktop:flex-row" style={{ paddingBottom: '30px' }}>
                    <div className="col-span-4 desktop:col-start-3 desktop:col-end-11">
                        <div className={`w-full flex flex-col desktop:flex-row items-center justify-center ${s.containerButtons}`}>
                            <Button
                                className={`${isPagaAbilitato() ? 'opacity-100 cursor-pointer' : 'opacity-50 cursor-not-allowed'} text-8 btn-paga-ora-tinaba ${s.btn}`}
                                disabled={!isPagaAbilitato()}
                                onClick={() => {
                                    onPagaTap();
                                }}>Paga con Tinaba</Button>
                            <div className={`text-center ${s.btnSeparator}`} style={{ minWidth: '134px' }}>oppure</div>
                            <Button
                                style={{ backgroundColor: 'white', borderWidth: '2px' }}
                                className={`text-primary border-primary text-8 btn-registrati-tinaba-premium ${s.btn}`}
                                onClick={() => {
                                    onRegistratiTap();
                                }}
                            >Registrati</Button>
                        </div>
                    </div>
                </div>
                <div aria-hidden="true" className="flex desktop:hidden absolute cursor-pointer" style={{ fontSize: '32px', right: '30px', top: '33px' }} onClick={onExitTap}>
                    <img src={xClose} alt="close" />
                </div>
            </div>
        </>
    )
}


export default ModalPagamento
